import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from '@cotyorg/ccx-atoms/Link';
import Picture from '@cotyorg/ccx-atoms/Picture';
import IconLink from '../IconLink';
import IconButton from '../IconButton';

const NavigationLink = ({
  name,
  pages,
  url,
  openInNewWindow,
  label,
  nested,
  isMobileNav,
  extraClass,
  iconExtraClass,
  textExtraClass,
  onClick,
  imageSrc,
  alt = '',
  imageSrcSet,
  selected,
  rightChevronIconSrc,
  textExtraId,
  doNotLazyLoad = true,
}) => {
  const childProps = {
    link: url,
    target: openInNewWindow ? '_blank' : null,
    extraClass: classNames('navigation-link', extraClass),
    onClick,
    iconAfterText: true,
    iconExtraClass,
    textExtraClass: classNames(textExtraClass, {
      'navigation__link-text--selected': selected,
    }),
    textExtraId,
  };

  const linkContents = (
    <span
      className={childProps.textExtraClass}
      {
        ...childProps.textExtraId ?
          { id: childProps.textExtraId } : {}
      }
    >
      { name }
    </span>
  );

  if (isMobileNav && pages && !!pages.length) {
    return <IconButton iconSrc={rightChevronIconSrc} {...childProps}>{linkContents}</IconButton>;
  }

  if (isMobileNav && !nested) {
    return <IconLink iconSrc={rightChevronIconSrc} {...childProps}>{linkContents}</IconLink>;
  }

  return (
    <Link {...childProps}>
      {imageSrc && (
        <div className="navigation-link__image-container flex-column align-middle">
          <Picture
            extraClass="navigation-link__image"
            src={imageSrc}
            alt={alt}
            srcset={imageSrcSet}
            doNotLazyLoad={doNotLazyLoad}
          />
          {label && (
            <p className="navigation-link__label">{label}</p>
          )}
        </div>
      )}
      {linkContents}
    </Link>
  );
};

NavigationLink.propTypes = {
  name: PropTypes.string.isRequired,
  pages: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
    pages: PropTypes.array,
    openInNewWindow: PropTypes.bool,
  })),
  url: PropTypes.string,
  openInNewWindow: PropTypes.bool,
  label: PropTypes.string,
  nested: PropTypes.bool,
  isMobileNav: PropTypes.bool,
  extraClass: PropTypes.string,
  iconExtraClass: PropTypes.string,
  textExtraClass: PropTypes.string,
  onClick: PropTypes.func,
  imageSrc: PropTypes.string,
  alt: PropTypes.string,
  rightChevronIconSrc: PropTypes.string,
  selected: PropTypes.bool,
  doNotLazyLoad: PropTypes.bool,
};

export default NavigationLink;
